export const indexCategories = [
  { id: 'zongyi', name: '综艺速报', icon: 'ri-tv-2-line', count: 1486, desc: '录制现场、阵容官宣与赛制变动' },
  { id: 'yingshi', name: '影视动态', icon: 'ri-film-line', count: 1732, desc: '定档排期、项目立项与制作进度' },
  { id: 'yinyue', name: '音乐演出', icon: 'ri-music-2-line', count: 1194, desc: '音乐节、巡演票务与现场反馈' },
  { id: 'zhibo', name: '直播生态', icon: 'ri-live-line', count: 968, desc: '平台规则、合约变化与分成机制' },
  { id: 'duanju', name: '短剧赛道', icon: 'ri-smartphone-line', count: 842, desc: '竖屏上新、题材分布与投放节奏' },
  { id: 'wanghong', name: '网红动向', icon: 'ri-user-star-line', count: 1375, desc: '创作者团队、账号变动与合作解约' },
  { id: 'saishi', name: '赛事转会', icon: 'ri-trophy-line', count: 726, desc: '转会窗口、阵容补强与官宣节奏' },
  { id: 'shangwu', name: '商务观察', icon: 'ri-briefcase-4-line', count: 634, desc: '代言合作、财报数据与预算调整' },
  { id: 'wenhua', name: '产业政策', icon: 'ri-building-2-line', count: 512, desc: '行业指引、合规要求与论坛观点' },
  { id: 'yule', name: '娱乐现场', icon: 'ri-mic-line', count: 1608, desc: '活动直击、公开行程与现场花絮' },
];

export const guideGroups = [
  {
    id: 'topic',
    title: '按题材索引',
    subtitle: '按内容类型快速进入对应目录',
    items: [
      { label: '综艺速报目录', count: 1486, category: 'zongyi' },
      { label: '影视动态目录', count: 1732, category: 'yingshi' },
      { label: '音乐演出目录', count: 1194, category: 'yinyue' },
      { label: '直播生态目录', count: 968, category: 'zhibo' },
      { label: '短剧赛项目录', count: 842, category: 'duanju' },
      { label: '网红动向目录', count: 1375, category: 'wanghong' },
    ],
  },
  {
    id: 'heat',
    title: '按热度索引',
    subtitle: '以讨论量与更新速度为维度',
    items: [
      { label: '今日最热榜', count: 50, href: '#ranking' },
      { label: '24小时飙升榜', count: 30, href: '#ranking' },
      { label: '编辑精选合辑', count: 24, href: '#topics' },
      { label: '讨论量 Top100', count: 100, href: '#ranking' },
      { label: '新晋条目速览', count: 68, href: '#feed' },
      { label: '长尾冷门名录', count: 212, href: '#index' },
    ],
  },
  {
    id: 'region',
    title: '按地区索引',
    subtitle: '按信息来源地域归档',
    items: [
      { label: '内地动态', count: 4218, href: '#feed' },
      { label: '港台动态', count: 1064, href: '#feed' },
      { label: '日韩动态', count: 892, href: '#feed' },
      { label: '欧美动态', count: 736, href: '#feed' },
      { label: '东南亚动态', count: 348, href: '#feed' },
      { label: '全球总览', count: 7258, href: '#overview' },
    ],
  },
  {
    id: 'time',
    title: '按时间归档',
    subtitle: '按更新周期回看历史条目',
    items: [
      { label: '24小时内', count: 218, href: '#feed' },
      { label: '近 3 天', count: 604, href: '#feed' },
      { label: '近 7 天', count: 1326, href: '#feed' },
      { label: '本月归档', count: 3894, href: '#feed' },
      { label: '季度回顾', count: 8940, href: '#overview' },
      { label: '年度总榜', count: 12486, href: '#overview' },
    ],
  },
];

export const overviewStats = [
  { label: '收录条目', value: '12,486', note: '持续增量归档' },
  { label: '索引分类', value: '36', note: '题材 / 地区 / 时间' },
  { label: '今日更新', value: '218', note: '较昨日 +12%' },
  { label: '专题合辑', value: '74', note: '编辑整理精选' },
];

export const overviewPoints = [
  { icon: 'ri-layout-masonry-line', title: '全收录结构', text: '条目统一入目录，标题与摘要分层呈现，浏览不跳档。' },
  { icon: 'ri-route-line', title: '按图索骥', text: '分类、热度、地区、时间四条索引线，快速定位目标内容。' },
  { icon: 'ri-time-line', title: '更新可追溯', text: '每条记录保留更新时间与热度值，回看历史一目了然。' },
];

export const footerColumns = [
  {
    title: '索引目录',
    links: ['黑料索引总览', '分类索引导航', '地区动态目录', '时间归档列表'],
  },
  {
    title: '热门入口',
    links: ['热度榜单', '专题合辑', '短讯速览', '编辑精选'],
  },
  {
    title: '使用说明',
    links: ['收录标准', '更新频率', '内容声明', '联系与反馈'],
  },
];